export default "__VITE_ASSET__K2AVFJzWK24VEk3_cP_5AQ__"